 import React from 'react';
 import { Input, Button, Select, Tag } from '@douyinfe/semi-ui';
 import { IconSearch, IconServer } from '@douyinfe/semi-icons';
 
 const ServerSelect = ({ baseUrls, activeTabKey, onTabChange, compact }) => {
     const options = Object.entries(baseUrls).map(([name]) => ({
         value: name,
         label: name,
     }));
 
     if (options.length <= 1) return null;
 
     return (
         <div style={{
             display: 'flex',
             alignItems: 'center',
             gap: 8,
             ...(compact ? {} : { justifyContent: 'center', marginBottom: 20 }),
         }}>
             <Tag
                 color="blue"
                 type="light"
                 size="large"
                 style={{ borderRadius: 8, padding: '2px 10px', flexShrink: 0 }}
             >
                 <IconServer style={{ fontSize: 14, marginRight: 4 }} />
                 线路
             </Tag>
             <Select
                 value={activeTabKey}
                 onChange={onTabChange}
                 optionList={options}
                 size={compact ? 'default' : 'large'}
                 style={{
                     width: compact ? 160 : 200,
                     borderRadius: 10,
                 }}
             />
         </div>
     );
 };
 
 const TokenInput = ({ apikey, setAPIKey, onSearch, loading, hasData, baseUrls, activeTabKey, onTabChange }) => {
     // 已查询状态 — 紧凑的顶部栏
     if (hasData) {
         return (
             <div style={{
                 marginBottom: 24,
                 display: 'flex',
                 alignItems: 'center',
                 gap: 12,
                 flexWrap: 'wrap',
             }}>
                 <ServerSelect baseUrls={baseUrls} activeTabKey={activeTabKey} onTabChange={onTabChange} compact />
                 <Input
                     size="default"
                     showClear
                     value={apikey}
                     onChange={setAPIKey}
                     placeholder="输入 API Key"
                     prefix={<IconSearch style={{ color: 'var(--apple-text-secondary)' }} />}
                     style={{
                         flex: 1,
                         minWidth: 200,
                         height: 40,
                         fontSize: 14,
                         borderRadius: 10,
                     }}
                     onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                 />
                 <Button
                     theme="solid"
                     type="primary"
                     onClick={onSearch}
                     loading={loading}
                     disabled={!apikey}
                     style={{
                         padding: '0 24px',
                         height: 40,
                         borderRadius: 10,
                         fontSize: 14,
                         background: 'var(--apple-blue)',
                     }}
                 >
                     查询
                 </Button>
             </div>
         );
     }
 
     // 未查询状态 — 居中大卡片
     return (
         <div className="search-area">
             <div className="apple-card glass-panel" style={{
                 padding: '40px 36px 36px',
                 textAlign: 'center',
             }}>
                 <h2 style={{
                     margin: '0 0 6px',
                     fontSize: 26,
                     fontWeight: 700,
                     color: 'var(--text-primary, #1d1d1f)',
                     letterSpacing: '-0.02em',
                 }}>
                     🔑 API 令牌查询
                 </h2>
                 <p style={{
                     margin: '0 0 28px',
                     color: 'var(--apple-text-secondary)',
                     fontSize: 14,
                     lineHeight: 1.5,
                 }}>
                     输入您的 Key 以查看余额和使用详情
                 </p>
 
                 <ServerSelect baseUrls={baseUrls} activeTabKey={activeTabKey} onTabChange={onTabChange} />
 
                 <Input
                     size="large"
                     showClear
                     value={apikey}
                     onChange={setAPIKey}
                     placeholder="sk-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                     prefix={<IconSearch style={{ fontSize: 18, color: 'var(--apple-text-secondary)' }} />}
                     style={{
                         height: 48,
                         fontSize: 15,
                         borderRadius: 12,
                         marginBottom: 14,
                     }}
                     onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                 />
                 <Button
                     theme="solid"
                     type="primary"
                     size="large"
                     onClick={onSearch}
                     loading={loading}
                     disabled={!apikey}
                     style={{
                         height: 48,
                         width: '100%',
                         borderRadius: 12,
                         fontSize: 16,
                         fontWeight: 600,
                         background: 'var(--apple-blue)',
                         boxShadow: '0 4px 14px rgba(0, 113, 227, 0.2)',
                     }}
                 >
                     查询详情
                 </Button>
             </div>
         </div>
     );
 };
 
 export default TokenInput;

